import { ref, readonly } from 'vue'
import type { Bookmark } from '../types/bookmark'
import type { VerseSelectionSubmit } from '../types/verseSelection'
import { apiClient } from '../services/apiClient'

// 全局狀態
const bookmarks = ref<Bookmark[]>([])
const loading = ref(false)
const error = ref<string | null>(null)

export function useGlobalBookmarks() {
  const loadBookmarks = async () => {
    loading.value = true
    try {
      error.value = null
      bookmarks.value = await apiClient.getAllBookmarks()
    } catch (e) {
      error.value = e instanceof Error ? e.message : 'Failed to load bookmarks'
    } finally {
      loading.value = false
    }
  }

  const addBookmark = async (
    payload: VerseSelectionSubmit,
    bookName: string,
    versionName: string,
  ): Promise<Bookmark> => {
    try {
      error.value = null
      const bookmarkData = {
        versionCode: payload.selection.versionCode!,
        bookId: payload.selection.bookId!,
        chapter: payload.selection.chapter!,
        verses: payload.verses,
        bookName,
        versionName,
      }
      const bookmark = await apiClient.createBookmark(bookmarkData)
      bookmarks.value = [...bookmarks.value, bookmark]
      return bookmark
    } catch (e) {
      error.value = e instanceof Error ? e.message : 'Failed to create bookmark'
      throw e
    }
  }

  const removeBookmark = async (bookmarkId: number) => {
    try {
      error.value = null
      await apiClient.deleteBookmark(bookmarkId)
      // 強制更新陣列以觸發響應式
      bookmarks.value = bookmarks.value.filter(b => b.id !== bookmarkId)
    } catch (e) {
      error.value = e instanceof Error ? e.message : 'Failed to delete bookmark'
      throw e
    }
  }

  return {
    bookmarks: readonly(bookmarks),
    loading: readonly(loading),
    error: readonly(error),
    loadBookmarks,
    addBookmark,
    removeBookmark,
  }
}
